import { generatePath } from 'react-router';
import { FORM_MODES } from '../../../config/formModes';
import { FORM_MODE_TO_PATH_MAP } from '../../../config/routes';
import { MODULE_NAME } from './module';
import { ENTITY_TO_PATH_MAP, ONBOARDING_FORM_PATH } from './routeTypes';

export const generateOnboardingFormPath = ({ entity }) =>
    generatePath(ONBOARDING_FORM_PATH, {
        module: MODULE_NAME,
        entity: ENTITY_TO_PATH_MAP[entity],
        mode: FORM_MODE_TO_PATH_MAP[FORM_MODES.CREATE],
    });
